import React from 'react';
import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path: string;
}

const ROUTE_LABELS: Record<string, string> = {
  '': 'Inicio',
  'home': 'Inicio',
  'catalog': 'Catálogo',
  'product': 'Producto',
  'cart': 'Carrito',
  'shipping': 'Envío',
  'payment': 'Pago',
  'checkout-review': 'Revisión',
  'success': 'Confirmación',
  'profile': 'Perfil',
  'addresses': 'Direcciones',
  'orders-history': 'Mis Pedidos',
  'tracking': 'Seguimiento',
  'wallet': 'Billetera',
  'wallet-topup': 'Cargar Saldo',
  'wallet-history': 'Historial',
  'club': 'Club AllTuc',
  'favorites': 'Favoritos',
  'wishlist': 'Lista de Deseos',
  'blog': 'Blog',
  'faq': 'Ayuda',
  'tiendas': 'Tiendas',
  'tienda': 'Tienda',
  'partner': 'Partner',
  'partner-dashboard': 'Dashboard',
  'partner-productos': 'Productos',
  'partner-servicios': 'Servicios',
  'partner-finanzas': 'Finanzas',
  'partner-reviews': 'Reviews',
  'admin': 'Admin',
  'benefits': 'Beneficios',
  'login': 'Iniciar Sesión',
  'register-success': 'Registro Exitoso',
  'onboarding': 'Bienvenido',
  'tuccoins-info': 'TucCoins',
  'legal': 'Legal'
};

export const Breadcrumbs: React.FC = () => {
  const location = useLocation();
  
  const breadcrumbs = React.useMemo<BreadcrumbItem[]>(() => {
    const paths = location.pathname.split('/').filter(Boolean);
    const items: BreadcrumbItem[] = [];
    
    // Only add 'Inicio' if we're not already on home
    if (location.pathname !== '/home' && location.pathname !== '/') {
      items.push({ label: 'Inicio', path: '/home' });
    }
    
    let currentPath = '';
    paths.forEach((segment, _index) => {
      currentPath += `/${segment}`;
      
      // Skip ID segments (they're usually dynamic)
      if (segment.match(/^[a-zA-Z0-9_-]{10,}$/)) {
        return;
      }
      
      const label = ROUTE_LABELS[segment] || 
                   ROUTE_LABELS[currentPath.replace(/^\//, '').replace(/\//g, '-')] ||
                   segment.charAt(0).toUpperCase() + segment.slice(1);
      
      items.push({
        label,
        path: currentPath
      });
    });
    
    return items;
  }, [location.pathname]);

  if (breadcrumbs.length === 0) return null;

  return (
    <nav className="px-4 py-2 bg-gray-50 dark:bg-gray-900/50 border-b border-gray-100 dark:border-white/5">
      <ol className="flex items-center gap-1 text-xs text-gray-500 dark:text-gray-400">
        {breadcrumbs.map((item, index) => (
          <React.Fragment key={item.path}>
            {index > 0 && (
              <span className="material-symbols-outlined text-sm">chevron_right</span>
            )}
            {index === breadcrumbs.length - 1 ? (
              <span className="font-medium text-gray-900 dark:text-white">
                {item.label}
              </span>
            ) : (
              <Link
                to={item.path}
                className="hover:text-primary transition-colors"
              >
                {item.label}
              </Link>
            )}
          </React.Fragment>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
